export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0 w-full lg:w-[420px]">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20inviting%20home%20entertainment%20scene%20with%20a%20large%20modern%20television%20screen%20on%20a%20minimalist%20media%20console%2C%20cozy%20throw%20blanket%20on%20a%20sofa%2C%20soft%20warm%20lighting%20from%20a%20floor%20lamp%2C%20indoor%20plants%2C%20cinematic%20atmosphere%2C%20clean%20Scandinavian%20interior%20design%2C%20warm%20neutral%20color%20palette%2C%20editorial%20photography%20with%20soft%20shadows&width=840&height=630&seq=about-platform-001&orientation=landscape"
                alt="努努影院平台介绍"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  target.parentElement!.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent rounded-2xl"></div>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              关于努努影院
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              努努影院诞生于对优质影视内容的热爱，致力于为广大剧迷打造一个<strong className="text-foreground-800">免费、高清、流畅</strong>的电视剧在线观看平台。我们深知追剧时卡顿和缓冲的痛苦，因此投入大量资源优化播放体验，确保每一集都能顺畅播完。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台汇聚了<strong className="text-foreground-800">国产热播剧、韩剧、美剧、日剧、动漫番剧以及经典老剧</strong>等丰富内容，每日实时同步各大平台的最新剧集更新。无论是当下流行的悬疑烧脑剧，还是让人欲罢不能的古装仙侠，你都能在这里第一时间找到。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              我们坚持<strong className="text-foreground-800">免费在线观看、全集播放、高清不缓冲</strong>的服务理念，去掉繁琐的注册流程，打开即看，让<strong className="text-foreground-800">流畅追剧</strong>回归最纯粹的体验。努努影院，陪你度过每一个追剧的温暖夜晚。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}